export default "__VITE_ASSET__DooZ3VNe__"